import Swiper from 'swiper';
import $ from 'jquery';

const tabContainers = document.querySelectorAll('.tabs-container');
const currentHash = window.location.hash.split('#')[1];

tabContainers.forEach(function (tabContainer) {
  /* VARIABLES */

  const tabContainerHeader = tabContainer.querySelector(
    '.tabs-heading__carousel .swiper-wrapper'
  );
  const tabs = tabContainer.querySelectorAll('.tab-content');
  const tabNames = [];
  let tabHeadingCarousel = null;
  let tabButtons = null;

  /* HELPERS */

  function stringToSlug(str) {
    str = str.replace(/^\s+|\s+$/g, ''); // trim

    str = str.toLowerCase(); // remove accents, swap ñ for n, etc

    const from = 'àáäâèéëêìíïîòóöôùúüûñçěščřžýúůďťň·/_,:;';
    const to = 'aaaaeeeeiiiioooouuuuncescrzyuudtn------';

    for (let i = 0, l = from.length; i < l; i++) {
      str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    str = str
      .replace('.', '-') // replace a dot by a dash
      .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
      .replace(/\s+/g, '-') // collapse whitespace and replace by a dash
      .replace(/-+/g, '-') // collapse dashes
      .replace(/\//g, ''); // collapse all forward-slashes

    return str;
  }

  function createTabButtons() {
    tabs.forEach(function (tab) {
      tabNames.push(stringToSlug(tab.getAttribute('data-name')));
    });
    tabs.forEach(function (tab, index) {
      const tabButton = document.createElement('BUTTON');
      tabButton.setAttribute('role', 'tab');
      tabButton.setAttribute(
        'class',
        'tab-button swiper-slide tabs-heading__item'
      );
      tabButton.setAttribute('id', tab.getAttribute('aria-labelledby'));
      tabButton.setAttribute('aria-controls', tab.getAttribute('id'));
      tabButton.setAttribute(
        'data-anchor',
        stringToSlug(tab.getAttribute('data-name'))
      );
      tabButton.innerHTML =
        '<span class="tabs__header__button__text">' +
        tab.getAttribute('data-name') +
        '</span>';

      if (
        index === 0 &&
        (currentHash === '' || !tabNames.includes(currentHash))
      ) {
        tabButton.setAttribute('aria-selected', true);
        tab.style.display = 'block';
      } else if (currentHash === tabButton.getAttribute('data-anchor')) {
        tabButton.setAttribute('aria-selected', true);
        tab.style.display = 'block';
      } else {
        tabButton.setAttribute('aria-selected', false);
        tab.setAttribute('hidden', true);
      }

      tabContainerHeader.appendChild(tabButton);
    });

    tabButtons = tabContainer.querySelectorAll('.tab-button');
  }

  function repositionCarousel(button) {
    const buttonIndex = Array.prototype.indexOf.call(
      tabContainerHeader.children,
      button
    );
    tabHeadingCarousel.slideTo(buttonIndex);
  }

  function changeCurrentTab(tabID, tabAnchor) {
    /* hide all tabs */
    tabButtons.forEach(function (tabButton) {
      tabButton.setAttribute('aria-selected', false);
    });
    tabs.forEach(function (tab) {
      tab.setAttribute('hidden', true);
      tab.style.display = 'none';
    });

    /* display newly selected tab */
    const relatedTabButton = tabContainer.querySelector(
      '.tab-button[aria-controls="' + tabID + '"'
    );
    const relatedTabPanel = document.getElementById(tabID);
    relatedTabPanel.removeAttribute('hidden');
    relatedTabPanel.style.display = 'block';
    relatedTabButton.setAttribute('aria-selected', true);

    /* change location state and reposition carousel */
    window.history.replaceState(null, null, '#' + tabAnchor);
    repositionCarousel(relatedTabButton);
  }

  function createTabsCarousel() {
    const carousel = new Swiper(
      tabContainer.querySelector('.tabs-heading__carousel'),
      {
        direction: 'horizontal',
        loop: false,
        slidesPerView: 'auto',
        watchOverflow: true,
        navigation: {
          nextEl: tabContainer.querySelector(
            '.tabs-heading__carousel__navigation .swiper-button-next'
          ),
          prevEl: tabContainer.querySelector(
            '.tabs-heading__carousel__navigation .swiper-button-prev'
          ),
        },
        a11y: {
          prevSlideMessage: 'Onglets précédents',
          nextSlideMessage: 'Onglets suivants',
        },
        on: {
          lock: () => {
            tabContainer.classList.add('locked-carousel');
          },
          unlock: () => {
            tabContainer.classList.remove('locked-carousel');
          },
        },
      }
    );

    tabContainer.querySelector('.tabs-heading').style.opacity = '1';

    return carousel;
  }

  function initFirstTab() {
    const currentTabButton = tabContainer.querySelector(
      '.tab-button[aria-selected="true"]'
    );

    if (currentTabButton) {
      repositionCarousel(currentTabButton);
    }
  }

  /* EVENTS */
  createTabButtons();
  tabHeadingCarousel = createTabsCarousel();
  initFirstTab();

  tabButtons.forEach(function (button) {
    button.addEventListener('click', function () {
      changeCurrentTab(
        button.getAttribute('aria-controls'),
        button.getAttribute('data-anchor')
      );
    });
  });

  window.addEventListener('hashchange', function () {
    const currentLocationHash = window.location.hash.split('#')[1];
    const tabsPosition = tabButtons[0].getBoundingClientRect();
    const currentButton = tabButtons.querySelector(
      '.tab-button[data-anchor="' + currentLocationHash + '"]'
    );

    if (currentButton) {
      changeCurrentTab(
        currentButton.getAttribute('data-controls'),
        currentLocationHash
      );
      window.scrollTo(0, tabsPosition.y);
    }
  });
});

// for accessibility

$(function () {
  const tabs = $('.block-tabs [role="tab"]');
  const tabList = $('.block-tabs  [role="tablist"]'); // Enable arrow navigation between tabs in the tab list

  let tabFocus = 0;
  $(tabList).on('keydown', function (event) {
    const code = event.keyCode || event.wich;
    const numberOfTabs = $(tabs).length; // Move right

    if (code === 39 || code === 37) {
      $(tabs[tabFocus]).attr('tabindex', -1);

      if (code === 39) {
        tabFocus++; // If we're at the end, go to the start

        if (tabFocus >= numberOfTabs) {
          tabFocus = 0;
        } // Move left
      } else if (code === 37) {
        tabFocus--; // If we're at the start, move to the end

        if (tabFocus < 0) {
          tabFocus = numberOfTabs - 1;
        }
      }

      $(tabs[tabFocus]).attr('tabindex', 0);
      $(tabs[tabFocus]).focus();
    }
  });
});
